import { Outlet } from "react-router"

export function Application() {
  return (
    <div className="size-full flex-col gap-y-3 overflow-x-auto overflow-y-hidden *:min-h-0 md:flex lg:px-4 xl:px-20">
      <Outlet />
    </div>
  )
}
